export default [
    {
        id: 'I',
        label: 'Infantry',
        maxunits: 5,
    },
    {
        id: 'V',
        label: 'Vehicle',
        maxunits: 3,
    },
];
